module.exports = __webpack_public_path__ + "static/media/close.0ba061e1.svg";